/*eslint-disable */
import common from "@/api/common";
import { message } from '@/assets/js/resetMessage';
import constants from "@/api/constants";
// 全局
export default {
	state: {
		setting: {},
		columnList: [],
		tagList: [],
		activeTag: {},
		currColumn: {},
		userInfo: {},
		comment_cache: {
			default: '',
		},
		accessToken: {},
	},
	mutations: {
		SET_STATE(state, {propName, value}) {
			state[propName] = value;
		},
		SET_SETTING(state, setting) {
			state.setting = setting;
		},
		SET_COLUMN_LIST(state, columnList) {
			state.columnList = columnList;
		},
		SET_TAG_LIST(state, tagList) {
			state.tagList = tagList;
		},
		SET_ACTIVE_TAG(state, activeTag) {
			state.activeTag = activeTag;
		},
		SET_CURR_COLUMN(state, currColumn) {
			state.currColumn = currColumn;
		},
		SET_USER_INFO(state, userInfo) {
			state.userInfo = userInfo;
		},
		SET_COMMENT_CACHE(state, comment_cache) {
			state.comment_cache = comment_cache;
		},
		SET_ACCESS_TOKEN(state, accessToken) {
			state.accessToken = accessToken;
		},
	},
	actions: {
		fetchData(store, {url, data, hideErrMsg = false}) {
			return common.requestData(url, data, result => {
				return result;
			}, () => {
			}, () => {
			}).catch(err => {
				if (!hideErrMsg) {
					message.error(err.message);
				}
				return Promise.reject(err);
			});
		},
		initCmsSetting(store) {
			return common.requestData(constants.API_GetCmsSetting, {}, result => {
				let resData = result.data || {};
				store.commit('SET_SETTING', resData);
				return resData;
			}).catch(err => {
				message.error(err.message);
				return Promise.reject(err);
			});
		},
	},
	getters: {}
}